import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import PropertyListPageUI from './PropertyListPageUI.js'

class PropertyListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      propertyList: null,
      updateMode: false,
      selectedProperty: null
    }
  }

  render() {
    return (
      <PropertyListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        propertyList={this.state.propertyList}
        selectedProperty={this.state.selectedProperty}
        updateMode={this.state.updateMode}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onUpdate={this.onUpdate}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getProperties(context)
  }

  getProperties(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/properties`,
      cacheKey: CacheKeys.Properties(),
      callback: this.getPropertiesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getPropertiesCallback = (response) => {
    this.setState({errorList: response.errorList, propertyList : response.propertyList}, this.highlightProperty)
  }

  highlightProperty = () => {
    const code = new URLSearchParams(window.location.search).get('highlight')
    if (!code) return
    setTimeout(() => {
      const el = document.querySelector(`[data-row-id="${code}"]`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' })
        el.classList.add('props_row_highlight')
        setTimeout(() => el.classList.remove('props_row_highlight'), 2000)
      }
    }, 100)
  }

  onUpdateClick = (event) => {
    let propertyName = event.currentTarget.getAttribute('data-property')
    console.log(propertyName);
    let selectedProperty = this.state.propertyList.filter(p => p.propertyName === propertyName)[0]
    this.setState({updateMode: true, selectedProperty: selectedProperty})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onUpdate = (selectedProperty) => {
    CacheManager.removeObject(CacheKeys.Properties())
    this.setState({propertyList : this.state.propertyList})
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.Properties())
    this.setState(
      {
        propertyList: null,
        errorList: null,
      }, this.getProperties(this.props.context)
    )
  }
}

export default PropertyListPageSF
